import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Order from "../pages/order/page";
import PremiumWines from "../pages/premium-wines/page";
import FineSpirits from "../pages/fine-spirits/page";
import LocalBeverages from "../pages/local-beverages/page";
import NonAlcoholic from "../pages/non-alcoholic/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/order",
    element: <Order />,
  },
  {
    path: "/premium-wines",
    element: <PremiumWines />,
  },
  {
    path: "/fine-spirits",
    element: <FineSpirits />,
  },
  {
    path: "/local-beverages",
    element: <LocalBeverages />,
  },
  {
    path: "/non-alcoholic",
    element: <NonAlcoholic />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
